import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { Suspense } from 'react';

import { defaultQueryClient } from './services/query-client.js';
import { router } from './services/router.js';

export function App() {
  return (
    <Suspense>
      <QueryClientProvider client={defaultQueryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </Suspense>
  );
}
